export default {
    opcaoGarantiaUnicaEnum: {
        SIM: 1,
        NAO: 2
    }
}


// WEBPACK FOOTER //
// ./src/helpers/opcao-garantia-unica.js